import { DatabaseLocation } from "./databaseLocation";

export class SQLiteResult {
    constructor(public success: boolean,
                public rows: any[],
                public error?: string,
                public insertId?: number) {
    }
}

export abstract class SqlProvider {
    abstract isInitialized(): boolean;

    abstract initialize(dbName: string,
                        location: DatabaseLocation): Promise<boolean>;

    abstract close(): Promise<boolean>;

    abstract query(queryText: string, bulkable?: boolean): Promise<SQLiteResult>;

    abstract getDbName(): string;

    abstract dropDatabase(): Promise<void>;

    abstract enableBulkWriting(): void;

    abstract commitBulk(): Promise<void>;

    abstract disableBulkWriting(): void;

    abstract getExistingTables(): Promise<string[]>;
}

